import { AppInsightsContext, ReactPlugin } from '@microsoft/applicationinsights-react-js'
import { ApplicationInsights as ApplicationInsightsWeb } from '@microsoft/applicationinsights-web'

import { environment } from './config/environment'

import type { ReactNode } from 'react'

let reactPlugin: ReactPlugin
let appInsights: ApplicationInsightsWeb

if (environment.azure.applicationInsights.connectionString) {
  reactPlugin = new ReactPlugin()
  appInsights = new ApplicationInsightsWeb({
    config: {
      connectionString: environment.azure.applicationInsights.connectionString,
      enableAutoRouteTracking: false,
      extensions: [reactPlugin],
    },
  })
  appInsights.loadAppInsights()
} else {
  console.warn('ApplicationInsights is not enabled.')
}

type ApplicationInsightsProps = {
  children: ReactNode
}

const ApplicationInsights = ({ children }: ApplicationInsightsProps) => {
  return reactPlugin ? (
    <AppInsightsContext.Provider value={reactPlugin}>{children}</AppInsightsContext.Provider>
  ) : (
    <>{children}</>
  )
}

export { ApplicationInsights, appInsights }
